'use client'

import { useSyncExternalStore } from 'react'

// Types
import type { DesktopOnlyProps } from '@/types/components/atoms/responsive'

// Same breakpoint as the theme's md
const QUERY = '(min-width: 900px)'

const subscribe = (onChange: () => void) => {
	const media = window.matchMedia(QUERY)

	media.addEventListener('change', onChange)

	return () => media.removeEventListener('change', onChange)
}

// Renders its children only on desktop screens, after load; phones never build or hydrate them.
// For decorative extras that are hidden on mobile anyway
const DesktopOnlyAtom = (props: DesktopOnlyProps) => {
	// Props
	const { children } = props

	// Variables
	const isDesktop = useSyncExternalStore(
		subscribe,
		() => window.matchMedia(QUERY).matches,
		() => false
	)

	return isDesktop ? children : null
}

export default DesktopOnlyAtom
